import * as actionTypes from '../constants/actionTypes';
import { updateObject } from '../../../../shared/utils';

const initialState = {
  originalPdfForms: null,
  originalPdfFormsError: null,
  originalPdfFormsLoading: false,

  downloadFlattenPdfForm: null,
  downloadFlattenPdfFormError: null,
  downloadFlattenPdfFormLoading: false,

  downloadOriginalPdfForm: null,
  downloadOriginalPdfFormError: null,
  downloadOriginalPdfFormLoading: false,
};

const getOriginalPdfFormsStart = (state, action) => {
  return updateObject(state, {
    originalPdfForms: null,
    originalPdfFormsError: null,
    originalPdfFormsLoading: true,
  });
};

const getOriginalPdfFormsSuccess = (state, action) => {
  return updateObject(state, {
    originalPdfForms: action.data,
    originalPdfFormsError: null,
    originalPdfFormsLoading: false,
  });
};

const getOriginalPdfFormsFail = (state, action) => {
  return updateObject(state, {
    originalPdfForms: null,
    originalPdfFormsError: action.error,
    originalPdfFormsLoading: false,
  });
};

const downloadFlattenPdfFormStart = (state, action) => {
  return updateObject(state, {
    downloadFlattenPdfFormError: null,
    downloadFlattenPdfFormLoading: true,
  });
};

const downloadFlattenPdfFormSuccess = (state, action) => {
  return updateObject(state, {
    downloadFlattenPdfForm: action.data,
    downloadFlattenPdfFormError: null,
    downloadFlattenPdfFormLoading: false,
  });
};

const downloadFlattenPdfFormFail = (state, action) => {
  return updateObject(state, {
    downloadFlattenPdfForm: null,
    downloadFlattenPdfFormError: action.error,
    downloadFlattenPdfFormLoading: false,
  });
};

const downloadOriginalPdfFormStart = (state, action) => {
  return updateObject(state, {
    downloadOriginalPdfFormError: null,
    downloadOriginalPdfFormLoading: true,
  });
};

const downloadOriginalPdfFormSuccess = (state, action) => {
  return updateObject(state, {
    downloadOriginalPdfForm: action.data,
    downloadOriginalPdfFormError: null,
    downloadOriginalPdfFormLoading: false,
  });
};

const downloadOriginalPdfFormFail = (state, action) => {
  return updateObject(state, {
    downloadOriginalPdfForm: null,
    downloadOriginalPdfFormError: action.error,
    downloadOriginalPdfFormLoading: false,
  });
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ORIGINAL_PDF_FORMS_GET_ORIGINAL_PDF_FORMS_START:
      return getOriginalPdfFormsStart(state, action);
    case actionTypes.ORIGINAL_PDF_FORMS_GET_ORIGINAL_PDF_FORMS_SUCCESS:
      return getOriginalPdfFormsSuccess(state, action);
    case actionTypes.ORIGINAL_PDF_FORMS_GET_ORIGINAL_PDF_FORMS_FAIL:
      return getOriginalPdfFormsFail(state, action);

    case actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_FLATTEN_PDF_FORM_START:
      return downloadFlattenPdfFormStart(state, action);
    case actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_FLATTEN_PDF_FORM_SUCCESS:
      return downloadFlattenPdfFormSuccess(state, action);
    case actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_FLATTEN_PDF_FORM_FAIL:
      return downloadFlattenPdfFormFail(state, action);

    case actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_ORIGINAL_PDF_FORM_START:
      return downloadOriginalPdfFormStart(state, action);
    case actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_ORIGINAL_PDF_FORM_SUCCESS:
      return downloadOriginalPdfFormSuccess(state, action);
    case actionTypes.ORIGINAL_PDF_FORMS_DOWNLOAD_ORIGINAL_PDF_FORM_FAIL:
      return downloadOriginalPdfFormFail(state, action);

    default:
      return state;
  }
};

export default reducer;
